import { toggleClass, addClass, removeClass } from './domHelpers.js';

export function setupEventListeners() {
  setupHamburgerMenu();
  setupLanguageSwitcher();
  setupHeaderScroll();
  setupSubmenuHandlers();
  setupSearchHandler();
}

function setupHamburgerMenu() {
  const hamb = document.querySelector('#nav-icon3');
  const menu = document.querySelector('.header-main__menu');

  if (hamb && menu) {
    hamb.addEventListener('click', () => {
      toggleClass(hamb, 'open');
      toggleClass(menu, 'only-mobile:translate-x-[100vw]', 'only-mobile:opacity-0');
      toggleClass(document.body, 'overflow-hidden', 'max-h-screen');
      closeSubmenu();
    });
  }
}

function setupLanguageSwitcher() {
  const langToggle = document.getElementById('lang-toggle');
  const langList = document.getElementById('lang-list');
  const arrow = document.getElementById('arrow');

  if (langToggle && langList && arrow) {
    langToggle.addEventListener('click', () => {
      toggleClass(langList, 'opacity-0', 'invisible', 'translate-y-2');
      toggleClass(arrow, 'rotate-90');
    });
  }
}

function closeLang() {
  const langList = document.getElementById('lang-list');
  const arrow = document.getElementById('arrow');

  if (langList && arrow) {
    addClass(langList, 'opacity-0', 'invisible', 'translate-y-2');
    addClass(arrow, 'rotate-90');
  }
}

function setupHeaderScroll() {
  const header = document.querySelector('.header');
  const headerHeight = header?.querySelector('.header__main')?.offsetHeight;
  const elAnchors = document.querySelector('.anchors');
  const stickyElement = document.querySelectorAll('.sticky-element');
  let lastScrollY = window.scrollY;

  if (window.innerWidth > 768 && header) {
    const topBarHeight = header.querySelector('.header__top')?.offsetHeight;

    window.addEventListener('scroll', () => {
      if (window.scrollY > lastScrollY) {
        header.style.transform = `translateY(-${topBarHeight}px)`;
        closeLang();
      } else {
        header.style.transform = 'translateY(0)';
      }

      if (elAnchors) {
        elAnchors.style.top = `${headerHeight + (window.scrollY > lastScrollY ? 0 : topBarHeight)}px`;
      }

      if(stickyElement){
        stickyElement.forEach((item) => {
          item.style.top = `${headerHeight + (window.scrollY > lastScrollY ? 0 : topBarHeight) + 20}px`;
        })
      }

      lastScrollY = window.scrollY;
    });
  }
}

let currentSubmenu = null;
let currentIcon = null;

function setupSubmenuHandlers() {
  document.querySelector('.header-main__menu')?.addEventListener('click', async (event) => {
    event.stopPropagation();
    const currentEl = event.target.closest('.header-main-menu__box');
    if (!currentEl) return;

    const submenu = currentEl.querySelector('.header-main-menu__submenu');
    const icon = currentEl.querySelector('.icon');

    if (window.innerWidth > 768 && currentSubmenu === submenu && event.target.parentNode !== submenu) {
      closeSubmenu();
      return;
    }

    if (currentSubmenu && currentSubmenu !== submenu) {
      closeSubmenu();
      await new Promise(resolve => setTimeout(resolve, 150));
    }

    currentSubmenu = submenu;
    currentIcon = icon;

    if (submenu && event.target.parentNode !== submenu.querySelector('.submenu-close')) {
      closeLang();
      closeSearch();
      removeClass(submenu, 'only-mobile:translate-x-full', 'tablet:-translate-y-[calc(100%_+_14rem)]', 'opacity-0', 'overflow-hidden');
    }

    if (icon && event.target.parentNode !== submenu.querySelector('.submenu-close')) {
      addClass(icon, 'tablet:!-rotate-90');
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.language-switcher')) closeLang();
    if (!event.target.closest('.header-main__menu') && window.innerWidth > 768) closeSubmenu();
    if (!event.target.closest('.header__main') && window.innerWidth <= 768) closeSubmenu();
  });

  document.querySelectorAll('.submenu-close').forEach((item) => {
    item.addEventListener('click', closeSubmenu);
  });
}

function closeSubmenu() {
  if (currentSubmenu) {
    addClass(currentSubmenu, 'only-mobile:translate-x-full', 'tablet:-translate-y-[calc(100%_+_14rem)]', 'opacity-0', 'overflow-hidden');
  }
  if (currentIcon) {
    removeClass(currentIcon, 'tablet:!-rotate-90');
  }
  currentSubmenu = null;
  currentIcon = null;
}

function setupSearchHandler() {
  const submenuSearch = document.querySelector('.header-submenu-search');

  document.querySelector('#search')?.addEventListener('click', () => {
    toggleClass(submenuSearch, '-translate-y-[calc(100%_+_14rem)]', 'opacity-0');
  });
}

function closeSearch() {
  const submenuSearch = document.querySelector('.header-submenu-search');
  addClass(submenuSearch, '-translate-y-[calc(100%_+_14rem)]', 'opacity-0');
}
